import { useState } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../../../../store';
import { ExternalSupervisorInvitation } from '../../../../store/types';

import SusyButton from '../../../shared/buttons/SusyButton';
import { AuthPageWrapper } from '../../Wrapper/authPageWrapper/AuthPageWrapper';
import { stringFormat } from 'susy-common/stringUtils';
import { SupervisorSignUpForm } from '../supervisorSignupForm/SupervisorSignUpForm';
import SignIn from '../../signIn/SignIn';

import './SupervisorInvitationLanding.css';

interface IProps {
    invitation: ExternalSupervisorInvitation;
}

export const SupervisorInvitationLanding = (props: IProps) => {
    const [isSignUpVisible, setIsSignUpVisible] = useState(false);
    const [isSignInVisible, setIsLoginVisible] = useState(false);

    const localization = useSelector(
        (state: RootState) =>
            state.localization.localizationStrings.susy.authentication
                .invitationLanding
    );

    const onAlreadyHaveASusyAccountBtnClick = async () => {
        setIsLoginVisible(true);
    };

    const onCreateAccountBtnClick = async () => {
        setIsSignUpVisible(true);
    };

    return (
        <>
            {!isSignUpVisible && !isSignInVisible && (
                <AuthPageWrapper
                    title={localization.title}
                    subtitle={localization.subtitle}
                    body={stringFormat(localization.body, [
                        props.invitation.invitedBy.firstName,
                    ])}
                >
                    <>
                        <div className='supervisor-invitation-landing-title susy-mb-5'>
                            {stringFormat(localization.body, [
                                props.invitation.invitedBy.firstName,
                            ])}
                        </div>
                        <SusyButton
                            text={localization.signInButtonText}
                            classes={'mb-3'}
                            fullWidth
                            onClickHandler={onAlreadyHaveASusyAccountBtnClick}
                            dataTestId='supervisorInvitationLanding-sign-in'
                        />
                        <div className='d-flex w-100 justify-content-center text-uppercase'>
                            {localization.or}
                        </div>
                        <SusyButton
                            text={localization.signUpButtonText}
                            classes={'mt-3'}
                            fullWidth
                            kind='secondary'
                            onClickHandler={onCreateAccountBtnClick}
                            dataTestId='supervisorInvitationLanding-sign-up'
                        />
                    </>
                </AuthPageWrapper>
            )}
            {isSignUpVisible && (
                <SupervisorSignUpForm invitation={props.invitation} />
            )}
            {isSignInVisible && <SignIn />}
        </>
    );
};
